export const deprecate = fn => fn;
export const types = {
  isNativeError: () => true
};
